/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Interaction from 'astro/server/interaction';

import * as Coords from 'shared/geo/coords';
import * as Shapes from 'shared/geo/shapes';


export default class extends Interaction
{
  installTargetPlanet (planet)
  {
    for (const coords of Shapes.getCoords(this.cass.target.id, this.cass.shape))
    {
      const target = planet.getZones().getOne(coords.toString());

      target.getAttributes().setInfluenceDisables(this.getDisabledLocations());
    }
  }


  installSourcePlanet (planet)
  {
    // no-op.
  }


  getDisabledLocations ()
  {
    let collection = [];

    for (const coords of Shapes.getCoords(this.cass.target.id, this.cass.shape))
    {
      collection.push({ id: coords.toString(), parent: this.cass.target.parent });
    }

    return collection;
  }


  isAggressive ()
  {
    return true;
  }


};
